import React, { useState } from "react";
import {
  Autocomplete,
  FormControlLabel,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import CardContent from "@mui/material/CardContent";
import { Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import { ColorButton, IOSSwitch } from "../common/CustomElement";
import { Button } from "@mui/material";
import CommonTable from "../common/CommonTable";
import { useNavigate } from "react-router-dom";
import CustomImageModal from "../common/CustomImageModal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IsApprove, Url } from "../global";
import CommonFilter from "../common/CommonFilter";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import NewDate from "../common/NewDate";
import { Add, EditRoadRounded, Info } from "@mui/icons-material";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(0),
  },
  "& .MuiInputBase-input": {
    borderRadius: 9,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "8px 26px 8px 10px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 9,
      borderColor: "#80bdff",
    },
  },
}));
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

const BootstrapDialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};
const LocationCompany = (prop) => {
  console.log(prop);
  const [param, setParam] = useState({
    start_date: "",
    end_date: "",
  });
  const navigate = useNavigate();
  const [searchKeyword, setSearchKeyword] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [checkStatus, setcheckStatus] = useState("");
  const [open, setOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  const [fullWidth, setFullWidth] = useState(true);
  const [resData, setResData] = useState({});
  const [maxWidth, setMaxWidth] = useState("sm");
  const [info, setInfo] = useState({
    name: "",
    alias: "",
    company: "",
    remark: "",
    company_list: [],
    location_id: "",
    isLoader: false,
  });
  const input1 = (event) => {
    var { name, value } = event.target;
    setInfo((prevalue) => {
      return {
        ...prevalue,
        [name]: value,
      };
    });
  };
  const [infoTrue, setinfoTrue] = useState({
    name: false,
    alias: false,
    company: false,
    remark: false,
  });
  const trueFalse = (event) => {
    var { name, value } = event.target;
    setinfoTrue((prevalue) => {
      return {
        ...prevalue,
        [name]: true,
      };
    });
  };
  const [searchBy, setSearchBy] = useState([
    {
      label: "ROLE NAME",
      value: false,
      name: "role",
    },
    {
      label: "NAME",
      value: false,
      name: "user_first_name",
    },
    {
      label: "Email",
      value: false,
      name: "user_email",
    },
    {
      label: "PAYMENT METHOD",
      value: false,
      name: "payment_method",
    },
    {
      label: "Phone Number",
      value: false,
      name: "user_phone",
    },
    {
      label: "MANAGER",
      value: false,
      name: "master_manager_name",
    },
    {
      label: "ACCOUNT TARGET",
      value: false,
      name: "ac_target",
    },
    {
      label: "MONEY IN TARGET",
      value: false,
      name: "master_manager_name",
    },
  ]);
  const re = /^[A-Za-z_ ]*$/;
  const [deleteCompany, setDeleteCopany] = useState({
    isLoader: false,
    company_id: "",
  });
  const handleClose = () => {
    setOpen(false);
  };
  toast.configure();

  const formAdd = () => {
    const param = new FormData();
    if (info.name == "") {
      toast.error("Location Name is required");
    } else if (info.alias == "") {
      toast.error("Location alias is required");
    } else if (info.company == "" || info.company == null) {
      toast.error("Company is required");
    } else {
      if (IsApprove !== "") {
        param.append("is_app", IsApprove.is_app);
        param.append("AADMIN_LOGIN_ID", IsApprove.AADMIN_LOGIN_ID);
        param.append("role_id", IsApprove.AADMIN_LOGIN_ROLE_ID);
      }
      param.append("company_id", info.company.company_id);
      param.append("location_name", info.name);
      param.append("location_alias", info.alias);
      param.append("location_remarks", info.remark);

      deleteCompany.isLoader = true;
      setDeleteCopany({ ...deleteCompany });
      info.isLoader = true;
      setInfo({ ...info });
      axios.post(Url + "/ajaxfiles/location_add.php", param).then((res) => {
        if (res.data.message == "Session has been expired") {
          localStorage.setItem("login", true);
          navigate("/login");
        }
        if (res.data.status == "error") {
          toast.error(res.data.message);
          info.isLoader = false;
          setInfo({ ...info });
        } else {
          toast.success(res.data.message);
          info.isLoader = false;
          setInfo({ ...info });
          setRefresh(!refresh);
          setOpen(false);
        }
      });
    }
  };
  const formDelete = () => {
    const param = new FormData();

    if (IsApprove !== "") {
      param.append("is_app", IsApprove.is_app);
      param.append("AADMIN_LOGIN_ID", IsApprove.AADMIN_LOGIN_ID);
      param.append("role_id", IsApprove.AADMIN_LOGIN_ROLE_ID);
    }
    param.append("location_id", deleteCompany.company_id);
    deleteCompany.isLoader = true;
    setDeleteCopany({ ...deleteCompany });
    axios.post(Url + "/ajaxfiles/location_delete.php", param).then((res) => {
      if (res.data.message == "Session has been expired") {
        localStorage.setItem("login", true);
        navigate("/login");
      }
      if (res.data.status == "error") {
        toast.error(res.data.message);
        deleteCompany.isLoader = false;
        setDeleteCopany({ ...deleteCompany });
      } else {
        toast.success(res.data.message);
        deleteCompany.isLoader = false;
        setDeleteCopany({ ...deleteCompany });
        setOpen(false);
        setRefresh(!refresh);
      }
    });
  };

  const formEdit = (prop) => {
    if (info.name == "") {
      toast.error("Location Name is required");
    } else if (info.alias == "") {
      toast.error("Location alias is required");
    } else {
      const param = new FormData();

      if (IsApprove !== "") {
        param.append("is_app", IsApprove.is_app);
        param.append("AADMIN_LOGIN_ID", IsApprove.AADMIN_LOGIN_ID);
        param.append("role_id", IsApprove.AADMIN_LOGIN_ROLE_ID);
      }
      param.append("company_id", info.company_id);
      param.append("location_name", info.name);
      param.append("location_alias", info.alias);
      param.append("location_remarks", info.remark);
      param.append("location_id", info.location_id);
      deleteCompany.isLoader = true;
      setDeleteCopany({ ...deleteCompany });
      info.isLoader = true;
      setInfo({ ...info });
      axios.post(Url + "/ajaxfiles/location_update.php", param).then((res) => {
        if (res.data.message == "Session has been expired") {
          localStorage.setItem("login", true);
          navigate("/login");
        }
        if (res.data.status == "error") {
          toast.error(res.data.message);
          info.isLoader = false;
          setInfo({ ...info });
        } else {
          toast.success(res.data.message);
          info.isLoader = false;
          setInfo({ ...info });
          setRefresh(!refresh);
          setOpen(false);
        }
      });
    }
  };
  const getCompanyData = () => {
    const param = new FormData();
    if (IsApprove !== "") {
      param.append("is_app", IsApprove.is_app);
      param.append("AADMIN_LOGIN_ID", IsApprove.AADMIN_LOGIN_ID);
      param.append("role_id", IsApprove.AADMIN_LOGIN_ROLE_ID);
    }
    axios.post(Url + "/ajaxfiles/get_company_list.php", param).then((res) => {
      if (res.data.message == "Session has been expired") {
        localStorage.setItem("login", true);
        navigate("/login");
      }
      if (res.data.status == "error") {
        // toast.error(res.data.message);
      } else {
        info.company_list = res.data.data;
        setInfo({ ...info });
      }
    });
  };
  console.log(info, "info");
  const chanestatus = (p1, id) => {
    const param = new FormData();
    if (IsApprove !== "") {
      param.append("is_app", IsApprove.is_app);
      param.append("AADMIN_LOGIN_ID", IsApprove.AADMIN_LOGIN_ID);
      param.append("role_id", IsApprove.AADMIN_LOGIN_ROLE_ID);
    }
    param.append("location_id", id);
    param.append("is_active", p1 == false ? 0 : 1);

    axios
      .post(Url + "/ajaxfiles/location_status_change.php", param)
      .then((res) => {
        if (res.data.message == "Session has been expired") {
          localStorage.setItem("login", true);
          navigate("/login");
        }
        if (res.data.status == "error") {
          toast.error(res.data.message);
        } else {
          toast.success(res.data.message);
        }
      });
  };
  const manageContent = () => {
    if (dialogTitle == "Delete Location") {
      return (
        <>
          <div>
            <h1>Are you sure ?</h1>
            Do you want to sure delete this Location ?
          </div>
        </>
      );
    } else if (
      dialogTitle == "Add Location" ||
      dialogTitle == "Edit Location"
    ) {
      return (
        <>
          <Grid container spacing={1}>
            <Grid item md={6}>
              <TextField
                id="standard-basic"
                label="Location Name"
                name="name"
                error={info.name == "" && infoTrue.name ? true : false}
                value={info.name}
                onChange={input1}
                onBlur={trueFalse}
                helperText={
                  info.name == "" && infoTrue.name
                    ? "Location Name is required"
                    : ""
                }
                className="w-100"
                variant="outlined"
              />
            </Grid>
            <Grid item md={6}>
              <TextField
                id="standard-basic"
                label="Alias"
                value={info.alias}
                error={info.alias == "" && infoTrue.alias ? true : false}
                helperText={
                  info.alias == "" && infoTrue.alias ? "Alias is required" : ""
                }
                onChange={input1}
                onBlur={trueFalse}
                name="alias"
                className="w-100"
                variant="outlined"
              />
            </Grid>
            {dialogTitle == "Add Location" ? (
              <Grid item md={6}>
                <Autocomplete
                  // disablePortal
                  options={info.company_list}
                  value={info.company}
                  getOptionLabel={(option) =>
                    option ? option.company_name : ""
                  }
                  onChange={(event, newValue) => {
                    info.company = newValue;
                    setInfo({ ...info });
                  }}
                  sx={{ padding: "0px" }}
                  className="w-100"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Company"
                      size="small"
                      onBlur={trueFalse}
                      name="company"
                      helperText={
                        (info.company == null || info.company == "") &&
                        infoTrue.company
                          ? "Company is required"
                          : ""
                      }
                      error={
                        (info.company == null || info.company == "") &&
                        infoTrue.company
                          ? true
                          : false
                      }
                      sx={{ padding: "0px" }}
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
            ) : (
              <Grid item md={6}>
                <TextField
                  disabled
                  label="Company"
                  size="small"
                  name="company"
                  className="w-100"
                  value={info.company}
                  sx={{ padding: "0px" }}
                  variant="outlined"
                />
              </Grid>
            )}

            <Grid item md={6}>
              <TextField
                id="standard-basic"
                label="Remark"
                value={info.remark}
                onChange={input1}
                name="remark"
                className="w-100"
                variant="outlined"
              />
            </Grid>
          </Grid>
        </>
      );
    }
  };
  const manageDialogActionButton = () => {
    if (dialogTitle == "Delete Location") {
      return (
        <div className="dialogMultipleActionButton">
          <Button
            variant="contained"
            className="cancelButton"
            onClick={handleClose}
          >
            Cancel
          </Button>
          {deleteCompany.isLoader ? (
            <Button
              tabindex="0"
              size="large"
              sx={{ padding: "12px 50px" }}
              className=" btn-gradient  btn-danger"
              disabled
            >
              <svg class="spinner" viewBox="0 0 50 50">
                <circle
                  class="path"
                  cx="25"
                  cy="25"
                  r="20"
                  fill="none"
                  stroke-width="5"
                ></circle>
              </svg>
            </Button>
          ) : (
            <Button
              variant="contained"
              className="btn-gradient btn-danger"
              onClick={formDelete}
            >
              Delete
            </Button>
          )}
        </div>
      );
    } else if (
      dialogTitle == "Add Location" ||
      dialogTitle == "Edit Location"
    ) {
      return (
        <div className="dialogMultipleActionButton">
          <Button
            variant="contained"
            className="cancelButton"
            onClick={handleClose}
          >
            Cancel
          </Button>
          {info.isLoader ? (
            <Button
              tabindex="0"
              size="large"
              sx={{ padding: "12px 40px" }}
              className=" btn-gradient  btn-danger"
              disabled
            >
              <svg class="spinner" viewBox="0 0 50 50">
                <circle
                  class="path"
                  cx="25"
                  cy="25"
                  r="20"
                  fill="none"
                  stroke-width="5"
                ></circle>
              </svg>
            </Button>
          ) : (
            <Button
              variant="contained"
              color="success"
              onClick={() => {
                if (dialogTitle == "Add Location") {
                  formAdd();
                } else {
                  formEdit();
                }
              }}
            >
              {dialogTitle == "Add Location" ? "Add" : "Edit"}
            </Button>
          )}
        </div>
      );
    }
  };
  const columns = [
    {
      name: "SR.NO",
      selector: (row) => {
        return <span>{row.sr_no}</span>;
      },
      reorder: true,
      wrap: true,
      grow: 0.1,
    },
    {
      name: "location code",
      selector: (row) => {
        return <span title={row.location_code}>{row.location_code}</span>;
      },
      sortable: true,
      reorder: true,
      grow: 0.3,
      wrap: true,
    },

    {
      name: "location name",
      selector: (row) => {
        return <span title={row.location_name}>{row.location_name}</span>;
      },
      sortable: true,
      reorder: true,
      grow: 1,
      wrap: true,
    },

    {
      name: "company name",
      selector: (row) => {
        return <span title={row.company_name}>{row.company_name}</span>;
      },
      sortable: true,
      reorder: true,
      grow: 0.7,
      wrap: true,
    },
    {
      name: "location remarks",
      selector: (row) => {
        return <span title={row.location_remarks}>{row.location_remarks}</span>;
      },
      sortable: true,
      reorder: true,
      grow: 0.9,
      wrap: true,
    },
    {
      name: "location status",
      selector: (row) => {
        return (
          <span title={row.location_status}>
            {" "}
            <FormControlLabel
              control={
                <IOSSwitch
                  sx={{ m: 2 }}
                  defaultChecked={row.location_status == 1 ? true : false}
                  //   checked={false}
                  onChange={(e) => {
                    chanestatus(e.target.checked, row.location_id);
                  }}
                />
              }
            />
          </span>
        );
      },
      sortable: true,
      reorder: true,
      grow: 0.7,
      wrap: true,
    },

    {
      name: "Action",
      selector: (row) => {
        return (
          <span style={{ display: "flex" }}>
            {" "}
            <Button>
              <span
                className="material-icons  icon_Mar"
                style={{ color: "green" }}
                onClick={() => {
                  setDialogTitle("Edit Location");
                  info.name = row.location_name1;
                  info.location_id = row.location_id;
                  info.remark = row.location_remarks;
                  info.company = row.company_name;
                  info.company_id = row.company_id;

                  info.alias = row.location_alias;
                  info.isLoader = false;

                  setInfo({ ...info });
                  setinfoTrue({
                    remark: false,
                    name: false,
                    alias: false,
                    company: false,
                  });
                  setOpen(true);
                }}
              >
                edit
              </span>
            </Button>
            <Button>
              <span
                className="material-icons  icon_Mar"
                style={{ color: "red" }}
                onClick={() => {
                  setDialogTitle("Delete Location");
                  deleteCompany.isLoader = false;
                  deleteCompany.company_id = row.location_id;
                  setDeleteCopany({ ...deleteCompany });
                  setOpen(true);
                }}
              >
                delete
              </span>
            </Button>
          </span>
        );
      },
      sortable: true,
      reorder: true,
      grow: 0.3,
      wrap: true,
    },
  ];

  return (
    <div>
      <div className="app-content--inner">
        <div className="app-content--inner__wrapper mh-100-vh">
          <div style={{ opacity: 1 }}>
            <Grid container>
              <Grid item md={12} lg={12} xl={12}>
                <p className="main-heading">Location</p>
                {/* <CommonFilter
                  search={searchBy}
                  setParam={setParam}
                  searchWord={setSearchKeyword}
                  setcheckStatus={setcheckStatus}
                  lastUpdatedBy={resData.modified_by_users}
                />
                <br /> */}

                <Paper
                  elevation={2}
                  style={{ borderRadius: "10px" }}
                  className="pending-all-15px"
                >
                  <CardContent className="py-3">
                    <Grid container spacing={2}>
                      <Grid item sm={12} md={12} lg={12}>
                        <ColorButton
                          onClick={() => {
                            info.isLoader = false;
                            info.company = prop.companyLocation.company;
                            info.name = "";
                            info.alias = "";
                            info.remark = "";
                            setInfo({ ...info });
                            setinfoTrue({
                              name: false,
                              alias: false,
                              company: false,
                              remark: false,
                            });
                            getCompanyData();
                            setDialogTitle("Add Location");

                            setOpen(true);
                          }}
                        >
                          Add Location
                        </ColorButton>

                        <CommonTable
                          url={`${Url}/datatable/location_list.php`}
                          column={columns}
                          sort="0"
                          refresh={refresh}
                          search={searchBy}
                          param={param}
                          searchWord={searchKeyword}
                          checkStatus={checkStatus}
                          setResData={setResData}
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Paper>
              </Grid>
              <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                className="modalWidth100"
                fullWidth={fullWidth}
                maxWidth={maxWidth}
              >
                <BootstrapDialogTitle
                  id="customized-dialog-title"
                  className="dialogTitle"
                  onClose={handleClose}
                >
                  {dialogTitle}
                </BootstrapDialogTitle>
                <DialogContent dividers>{manageContent()}</DialogContent>
                <DialogActions>{manageDialogActionButton()}</DialogActions>
              </BootstrapDialog>
            </Grid>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationCompany;
